var CODE_FIELDS, FIELDS_MAP, FIELDS_WITH_EDITOR_VALUE, FIELDS_WITH_MISSING, FIELDS_WITH_SEMICOLON, REST_FIELDS, YES_NO_TEXT_FIELDS, calculateTrustworthiness, exportAgreeScore, exportAndSplitBySemicolon, exportCodes, exportFieldWithMissing, exportGuideline, exportGuidelineFields, exportYesNoTextField, get, renderEditorValue, _ref;

_ref = require('lib/services/covid_exporter/utils'), calculateTrustworthiness = _ref.calculateTrustworthiness, exportAgreeScore = _ref.exportAgreeScore, exportAndSplitBySemicolon = _ref.exportAndSplitBySemicolon, exportGuidelineFields = _ref.exportGuidelineFields, exportFieldWithMissing = _ref.exportFieldWithMissing, exportYesNoTextField = _ref.exportYesNoTextField, exportCodes = _ref.exportCodes, renderEditorValue = _ref.renderEditorValue;

get = require('lodash').get;

YES_NO_TEXT_FIELDS = ['consumerEngagement', 'declarationOfInterestManaged', 'guidelineUpdatePlans', 'guidelineGroupDetails', 'peopleWithLivedExperience'];

CODE_FIELDS = ['guidelineInterventions', 'guidelinePopulations'];

FIELDS_MAP = {
  'fullReference': 'citation',
  'targetAudience': 'users'
};

FIELDS_WITH_MISSING = ['secondWorldRegionCategory'];

FIELDS_WITH_SEMICOLON = ['source'];

FIELDS_WITH_EDITOR_VALUE = ['generalDescription', 'disclaimer', 'certaintyOfEvidenceTextInput', 'strengthOfRecommendationText'];

REST_FIELDS = ['authors', 'contactAddress', 'contactEmail', 'contactName', 'contactTelephone', 'contactWeb', 'countryFlag', 'department', 'doi', 'equityConsiderations', 'field', 'fundingBody', 'fullReference', 'gradebookChapter', 'guidelineLanguage', 'institutionLogoUrl', 'institutionName', 'institutionShortName', 'isbn', 'issn', 'language', 'latestLiteratureSearchDate', 'linksAndVideos', 'oldGradebookLink', 'organizationType', 'owner', 'pmid', 'publicationDate', 'publishLastSearchDate', 'researchPriorities', 'sourceDocumentLink', 'targetAudience', 'title', 'topic', 'worldRegion', 'version', 'versionMajor', 'versionMinor'];

exportGuideline = function(projectId, guidelineDoc) {
  var agreeScore, codesFields, fieldsWithDraftEditor, fieldsWithMissing, fieldsWithSemicolon, publicationYear, restFields, trustworthiness, trustworthinessFields, yesNoTextFields;
  agreeScore = exportAgreeScore(guidelineDoc);
  trustworthinessFields = ['editorialIndependence', 'rigorOfDevelopment', 'scopeAndPurpose'];
  trustworthiness = calculateTrustworthiness(agreeScore, trustworthinessFields);
  publicationYear = guidelineDoc['publicationDate'] ? moment(guidelineDoc['publicationDate']).format('YYYY') : void 0;
  yesNoTextFields = exportGuidelineFields(exportYesNoTextField, YES_NO_TEXT_FIELDS, FIELDS_MAP, guidelineDoc);
  fieldsWithDraftEditor = exportGuidelineFields(renderEditorValue, FIELDS_WITH_EDITOR_VALUE, FIELDS_MAP, guidelineDoc);
  codesFields = _.chain(CODE_FIELDS).map(function(field) {
    return [field, exportCodes(guidelineDoc[field])];
  }).object().value();
  fieldsWithMissing = exportGuidelineFields(exportFieldWithMissing, FIELDS_WITH_MISSING, FIELDS_MAP, guidelineDoc);
  fieldsWithSemicolon = exportGuidelineFields(exportAndSplitBySemicolon, FIELDS_WITH_SEMICOLON, FIELDS_MAP, guidelineDoc);
  restFields = exportGuidelineFields(_.identity, REST_FIELDS, FIELDS_MAP, guidelineDoc);
  return _.extend({
    '@id': guidelineDoc['slug'],
    agreeScore: agreeScore,
    trustworthiness: trustworthiness,
    originalId: projectId,
    publicationYear: publicationYear
  }, fieldsWithSemicolon, yesNoTextFields, codesFields, fieldsWithMissing, fieldsWithDraftEditor, restFields);
};

module.exports = exportGuideline;
